module.exports = __webpack_public_path__ + "img/TT.05d96721.svg";